<template>
  <v-container class="fill-height with-fancy-bg">
    <v-row
      align="center"
      justify="center"
      class="fill-height">
      <v-col>
        <v-card
          class="mx-auto"
          max-width="688px">
          <div class="right-language-switcher">
            <LanguageSwitcher />
          </div>
          <v-card-title class="text-center mt-10 auth-forms-top-title">
            <span class="text-primary">{{
              $t("views.ThankYou.ThankYou")
            }}</span>
            <br />
            {{ $t(`views.ThankYou.actions.${route.params.action}.title`) }}
          </v-card-title>
          <v-card-subtitle class="auth-forms-sub-title text-center">
            {{ $t(`views.ThankYou.actions.${route.params.action}.subtitle`) }}
          </v-card-subtitle>

          <v-card-text>
            <v-row class="mt-6">
              <v-col class="text-center">
                <v-btn
                  block
                  class="text-none text-subtitle-1"
                  prepend-icon="mdi-check"
                  size="large"
                  rounded="xl"
                  color="primary"
                  variant="flat"
                  data-cy="continue-button"
                  @click="router.push(actionButton)">
                  {{ $t("actions.continue") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import LanguageSwitcher from "../../components/tools/LanguageSwitcher.vue";

const route = useRoute();
const router = useRouter();

const actionButton = ref({ name: "login" });

switch (route.params.action) {
  case "signup":
    actionButton.value = { name: "login" };
    break;
}
</script>
